import React from 'react';
import PressContent from '../components/PressContent';

const Press = () => {
  return <PressContent/>;
};

export default Press;
